import "./styles/index.scss";

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./scenes/app/App";
import { unregister } from "./serviceWorkerRegistration";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
unregister();
